import { render, staticRenderFns } from "./ClinicDashboard.vue?vue&type=template&id=bf096e26&scoped=true"
import script from "./ClinicDashboard.vue?vue&type=script&lang=js"
export * from "./ClinicDashboard.vue?vue&type=script&lang=js"
import style0 from "./ClinicDashboard.vue?vue&type=style&index=0&id=bf096e26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf096e26",
  null
  
)

export default component.exports